<div class="col-md-12">
    <h4 class="title-f">Customer Level Exposure</h4>
    <mat-icon style="cursor:pointer;text-align: right;width: 100%;margin-bottom: 13px;margin-top: -10px;" mat-button (click)="close()">close</mat-icon>
    <div class="doc-table">
      <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="false" [rows]="5"
        [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [globalFilterFields]="['type']">
        <ng-template pTemplate="header">
          <tr style="text-align: center;">
            <th>Loan / C C No.</th>
            <th>Customer ID</th>
            <th>Customer Name</th>
            <th>Customer Profile</th>
            <th>A/C Block Code Status</th>
            <th>Agreement ID</th>
            <th>Collector</th>
            <th>Product Name</th>
            <th>Cycle</th>
            <th>DPD</th>
            <th>Minimum Due/Installments</th>
            <th>Overdue</th>  
            <th>Outstanding Amount</th>
            <th>Deliquency String</th>
          </tr>
          <tr style="text-align: center;">
            <td>005252584558752</td>
            <td>0000000147145475</td>
            <td>Jone Doe</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>NBD CARDS</td>
            <td>6</td>
            <td>210</td>
            <td>0</td>
            <td>558,888.13</td>
            <td>1,091,729.40</td>
            <td>[D-N--O--S--A--J--J--M--A--F--G]
              [9--9--9--9--9--9--9-9--9--9--9]
            </td>
          </tr>
          <!-- <tr>
            <th colspan="10">Total</th>
            <th>0</th>
            <th>558,882.13</th>
            <th colspan="2">1,091,729.40</th>

          </tr> -->
        </ng-template>
       </p-table>  </div>
    </div>
    <div class="doc-table total" style="margin-top: 20px;">
        <h4 class="title-f">Total</h4>
        <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="false" [rows]="5"
          [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          [globalFilterFields]="['type']">
          <ng-template pTemplate="header">
            <tr style="text-align: center;">
              <th>Minimum Due/Installments</th>
              <th>Overdue</th>  
              <th>Outstanding Amount</th>
            </tr>
            <tr>
              <td class="text-center">0</td>
              <td class="text-center">558,882.13</td>
              <td class="text-center">1,091,729.40</td>
  
            </tr>
          </ng-template>
         </p-table>  </div>
      </div>
  </div>